import React from 'react'

const TickIcon = () => {
    return (
        <div className='verified_icon'>
            <span></span>
        </div>
    )
}

export default TickIcon